import React, { useState, useEffect } from 'react';
import { Button, Form, Input, notification, Typography} from 'antd';
import { generateOTPService, resendOTPService, verifyOTPExchnageService } from '../../../../services/master-services';
import { API_RESPONSE_CODES } from '../../../../utills/constant';
import Loader from '../../../../components/common/Loader';
import { fetchLeadDetailsServices } from '../../../auth/slice/authSlice';
import { useDispatch } from 'react-redux';


const { Title, Text } = Typography;

const OTPVerification = ({ leadViewDetails, onOTPVerified, leadId }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(false);
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [showGenerate, setShowGenerate] = useState(true);
  const dispatch = useDispatch();

  const phone_no = leadViewDetails?.customer?.phone_no;

  const handleGenerateOTP = async () => {
    if (!phone_no) return;
    
    try {
      setIsLoading(true);
      const response = await generateOTPService({
        phone_no: phone_no,
        type: 'evaluation',
      });
      if (response.data.status === API_RESPONSE_CODES.OK) {
        notification.success({
          message: response.data.data || 'OTP sent successfully',
        });
        setCountdown(30);
        setCanResend(false); // Initially disabled during countdown
        setOtpEnabled(true);
        setShowGenerate(false);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [countdown]);

  // const handleSendOTP = async () => {
  //   if (!phone_no) return;
    
  //   try {
  //     setIsLoading(true);
  //     const response = await generateOTPService({
  //       phone_no: phone_no,
  //       type: 'evaluation'
  //     });
      
  //     if (response.data.status === API_RESPONSE_CODES.OK) {
  //       notification.success({
  //         message: 'OTP sent successfully',
  //       });
  //       setCountdown(60);
  //       setCanResend(false);
  //     }
  //   } catch (error) {
  //     notification.error({
  //       description: error.response?.data?.message ?? error?.message,
  //     });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleVerifyOTP = async () => {
    if (!otp || !phone_no || !leadId) return;
  
    try {
      setIsLoading(true);
      const exchangeStageHistory = leadViewDetails?.exchange_stage_history || [];
      // find current stage
      const currentInProgressStage = exchangeStageHistory.find(
        (stage) => stage.status === 1
      );
  
      // prepare payload
      const payload = {
        otp,
        phone_no,
        lead_id: leadId,
        current_stage_id: currentInProgressStage?.lead_exchange_stage_id ?? null,
        next_stage_id: 2,
        type: "evaluation", // required by backend
      };
  
      const response = await verifyOTPExchnageService(payload);
      if (response.data.status === API_RESPONSE_CODES.OK) {
        notification.success({
          message: response.data.data || "OTP verified successfully",
        });
        await dispatch(fetchLeadDetailsServices({ id: leadId }));
        onOTPVerified();
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
      form.setFieldsValue({ otp: "" });
      setOtp("");
    } finally {
      setIsLoading(false);
    }
  };
  
  
  const handleResendOTP = async () => {
    if (!phone_no || !canResend) return;

    try {
      setIsLoading(true);
      const response = await resendOTPService(phone_no);
      if (response.data.status === API_RESPONSE_CODES.OK) {
        notification.success({
          message: response.data.data || 'OTP resent successfully',
        });
        setCountdown(30);
        setCanResend(false);
        // setOtpSent(true); // Keep the flag true since OTP was sent
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Loader loading={isLoading} />
      <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: '20px' }}>
          <Title level={4} style={{ fontSize: '18px' }}>Verify OTP</Title>
          <Text type="secondary">
            Enter the OTP sent to {phone_no}.
          </Text>
        </div>

        <div style={{ marginBottom: '20px' }}>
          {showGenerate && (
            <Button
              type="primary"
              onClick={handleGenerateOTP}
              loading={isLoading}
              className='secondary-button' 
            >
              Generate OTP
            </Button>
          )}
        </div>

        <Form form={form} layout="inline">
          <Form.Item
            label={<span>Enter OTP <span style={{ color: 'red' }}>*</span></span>}
            name="otp"
            rules={[
              { required: true, message: 'Please enter OTP' },
              { len: 4, message: 'OTP must be 4 digits' }
            ]}
            style={{ marginRight: '16px' }}
            labelCol={{ style: { marginRight: '20px' } }}
          >
            <Input
              placeholder="OTP"
              maxLength={4}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              disabled={!otpEnabled}
              style={{ 
                textAlign: 'center', 
                fontSize: '18px', 
                letterSpacing: '2px', 
                width: '200px'
              }}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              onClick={handleVerifyOTP}
              disabled={!otp || otp.length !== 4}
              className='secondary-button' 
            >
              Verify OTP
            </Button>
          </Form.Item>

          <Form.Item>
            {!showGenerate && (
              countdown > 0 ? (
                <Text type="secondary">
                  Resend in {countdown}s
                </Text>
              ) : (
                <Button
                  type="primary"
                  onClick={handleResendOTP}
                  disabled={!canResend}
                  className='secondary-button'
                 
                >
                  Resend OTP
                </Button>
              )
            )}
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default OTPVerification;
